import React, {Component} from 'react';

export default class FullSizeContent extends Component {
  render() {
    return <div className="h-100 w-100 d-flex justify-content-center align-items-center" {...this.props} />;
  }
}
